export default {
  views: {
    dashboard: { ready: false },
    members: { ready: false }
  },
  branch: 0,
  ready: false,
  loading: true,
  menu: [],
  user: {},
  lang: {},
  validation: {
    hasError: false
  }
}



// WEBPACK FOOTER //
// ./scripts/store/initial-state.js